// removed by extract-text-webpack-plugin
module.exports = {"text":"Course__text___1iROl","change-course":"Course__change-course___1RlbP"};